// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-table .ant-table-tbody > tr.even-row > td {
    background-color: white; /* White background for even rows */
  }
  
  .order-table .ant-table-tbody > tr.odd-row > td {
    background-color: #f5f5f5; /* Light gray background for odd rows */
  }
  .country-modal .ant-modal-close-x {
    color: black !important;
  }
  .ant-table-cell-fix-left {
    z-index: 1000 !important; /* Ensure it applies higher z-index */
    background-color: white;  /* Optional: Ensure a solid background to cover scrolling content */
  }
  
  .create-order .ant-modal-content {
    padding: 0 0px 13px 0 !important;
    border-radius: 12px;
  }
  
  .create-order .ant-modal-body {
    padding: 16px;
  }
  
  .create-order .ant-modal-footer {
    padding: 10px 20px;
  }
  
  .create-order .ant-btn-primary {
    background-color: #040724 !important;
  }
  
  .create-order .ant-btn-disabled:hover {
    background-color: #040724 !important;
  }
  
  .custom-modal-header {
    color: white;
    background-color: #040724;
    padding: 10px 0px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    margin: 0;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
  }
  
  .file-parent {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-end;
    min-width: 100%;
    border: 1px solid #d9d9d9;
    border-radius: 10px;
  
  }
  .file-parent2 {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-end;
    min-width: 40%;
    margin-top: 10px;
    border: 1px solid #d9d9d9;
    border-radius: 10px;
  
  }

  .file-container {
    display: flex;
  
    justify-content: flex-start;
    align-items: flex-end;
    min-width: 100%;
  
  }
  
  .react-editor{
    min-height: 300px!important;
  }
  
  .custom-radio-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    position: relative;
  
  }
  
  /* Hidden default radio input */
  .custom-radio-input {
    display: none;
  }`, "",{"version":3,"sources":["webpack://./src/components/css/OrderTable.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB,EAAE,mCAAmC;EAC9D;;EAEA;IACE,yBAAyB,EAAE,uCAAuC;EACpE;EACA;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB,EAAE,qCAAqC;IAC/D,uBAAuB,GAAG,mEAAmE;EAC/F;;EAEA;IACE,gCAAgC;IAChC,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;IACjB,2BAA2B;IAC3B,4BAA4B;IAC5B,SAAS;IACT,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,qBAAqB;IACrB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;;EAErB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;;EAErB;;EAEA;IACE,aAAa;;IAEb,2BAA2B;IAC3B,qBAAqB;IACrB,eAAe;;EAEjB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,kBAAkB;;EAEpB;;EAEA,+BAA+B;EAC/B;IACE,aAAa;EACf","sourcesContent":[".order-table .ant-table-tbody > tr.even-row > td {\n    background-color: white; /* White background for even rows */\n  }\n  \n  .order-table .ant-table-tbody > tr.odd-row > td {\n    background-color: #f5f5f5; /* Light gray background for odd rows */\n  }\n  .country-modal .ant-modal-close-x {\n    color: black !important;\n  }\n  .ant-table-cell-fix-left {\n    z-index: 1000 !important; /* Ensure it applies higher z-index */\n    background-color: white;  /* Optional: Ensure a solid background to cover scrolling content */\n  }\n  \n  .create-order .ant-modal-content {\n    padding: 0 0px 13px 0 !important;\n    border-radius: 12px;\n  }\n  \n  .create-order .ant-modal-body {\n    padding: 16px;\n  }\n  \n  .create-order .ant-modal-footer {\n    padding: 10px 20px;\n  }\n  \n  .create-order .ant-btn-primary {\n    background-color: #040724 !important;\n  }\n  \n  .create-order .ant-btn-disabled:hover {\n    background-color: #040724 !important;\n  }\n  \n  .custom-modal-header {\n    color: white;\n    background-color: #040724;\n    padding: 10px 0px;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n    margin: 0;\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: space-between;\n  }\n  \n  .file-parent {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: flex-end;\n    min-width: 100%;\n    border: 1px solid #d9d9d9;\n    border-radius: 10px;\n  \n  }\n  .file-parent2 {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: flex-end;\n    min-width: 40%;\n    margin-top: 10px;\n    border: 1px solid #d9d9d9;\n    border-radius: 10px;\n  \n  }\n\n  .file-container {\n    display: flex;\n  \n    justify-content: flex-start;\n    align-items: flex-end;\n    min-width: 100%;\n  \n  }\n  \n  .react-editor{\n    min-height: 300px!important;\n  }\n  \n  .custom-radio-container {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n    position: relative;\n  \n  }\n  \n  /* Hidden default radio input */\n  .custom-radio-input {\n    display: none;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
